import "./assets/main.css";
import "primeicons/primeicons.css";
import "./assets/fonts.css";
import { createApp } from "vue";
import App from "./App.vue";
import { createPinia } from "pinia";
import router from "./router";
import PrimeVue from "primevue/config";
import AppState from "./plugins/appState";
import PrimeVueComponents from "./plugins/primevue";

import Noir from "./presets/Noir.js";
import i18n from "./i18n";
import BaseButton from "./components/Base/BaseButton.vue";
import BaseSelect from "./components/Base/BaseSelect.vue";
import BaseInputOtp from "./components/Base/BaseInputOtp.vue";
import BaseInput from "./components/Base/BaseInput.vue";
import BaseDialog from "./components/Base/BaseDialog.vue";
import AgentCardComponent from "./views/EstatePlan/CommonComponent/AgentCardComponent.vue";
import SuccessRequestDialog from "@/views/EstatePlan/CommonComponent/SuccessDialog.vue";
import SendRequestPrincipalBackupPersonModal from "./views/EstatePlan/CommonComponent/SendRequestPrincipalBackupPersonModal.vue";
import AuthenticateAccountAgent from "./views/EstatePlan/CommonComponent/AuthenticateAccountAgent.vue";
import GenerateCodeComponent from "./views/EstatePlan/CommonComponent/GenerateCodeComponent.vue";
import ValidateComponent from "./views/EstatePlan/CommonComponent/ValidateComponent.vue";
import AuthenticateComponent from "./views/EstatePlan/CommonComponent/AuthenticateCode.vue";
import BaseSkeleton from "./components/Base/BaseSkeleton.vue";
import ProfileTabs from "./views/Profile/ProfileTabs.vue";
import BaseDateTimePicker from "./components/Base/BaseDateTimePicker.vue";
import SelectPrincipalBackupPersonModal from "./views/EstatePlan/CommonComponent/SelectPrincipalBackupPersonModal.vue";
import BaseMenu from "./components/Base/BaseMenu.vue";
import ConfirmationDialog from "./components/ConfirmationDialog.vue";
import SuccessDialog from "./components/SuccessDialog.vue";
import BaseSwitch from "@/components/Base/BaseSwitch.vue";
import BaseConfirmation from "@/components/Base/BaseConfirmation.vue";
import EstatePlanBreadcrumb from "@/layout/EstatePlanBreadcrumb.vue";
import CashBequestCardComponent from "@/views/EstatePlan/CommonComponent/CashBequestCardComponent.vue";
import DisinheritCard from "@/views/EstatePlan/CommonComponent/DisinheritCard.vue";
import BaseCarouselNew from "@/components/Base/BaseCarouselNew.vue";
import BaseRadio from "@/components/Base/BaseRadio.vue";
import UnsavedChangesWarningModal from "@/components/Base/UnsavedChangesWarningModal.vue";
import BaseTooltip from "@/components/Base/BaseTooltip.vue";

const app = createApp(App);

// Expose i18n globally for utility functions   main.js
if (globalThis.window !== undefined) {
  globalThis.window.__VUE_I18N__ = i18n;
}

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(AppState);
app.use(PrimeVue, {
  theme: {
    preset: Noir,
    options: {
      prefix: "p",
      darkModeSelector: ".p-dark",
      cssLayer: false,
    },
  },
});
app.use(PrimeVueComponents);
app.component("BaseDateTimePicker", BaseDateTimePicker);
app.component("BaseButton", BaseButton);
app.component("BaseSelect", BaseSelect);
app.component("BaseInputOtp", BaseInputOtp);
app.component("BaseInput", BaseInput);
app.component("BaseDialog", BaseDialog);
app.component("BaseTooltip", BaseTooltip);
app.component("AgentCardComponent", AgentCardComponent);
app.component("SuccessRequestDialog", SuccessRequestDialog);
app.component(
  "SendRequestPrincipalBackupPersonModal",
  SendRequestPrincipalBackupPersonModal
);
app.component("AuthenticateAccountAgent", AuthenticateAccountAgent);
app.component("GenerateCodeComponent", GenerateCodeComponent);
app.component("ValidateComponent", ValidateComponent);
app.component("AuthenticateComponent", AuthenticateComponent);
app.component("BaseSkeleton", BaseSkeleton);
app.component("ProfileTabs", ProfileTabs);
app.component("BaseMenu", BaseMenu);
app.component("ConfirmationDialog", ConfirmationDialog);
app.component("SuccessDialog", SuccessDialog);
app.component(
  "SelectPrincipalBackupPersonModal",
  SelectPrincipalBackupPersonModal
);
app.component("BaseSwitch", BaseSwitch);
app.component("BaseConfirmation", BaseConfirmation);
app.component("EstatePlanBreadcrumb", EstatePlanBreadcrumb);
app.component("DisinheritCard", DisinheritCard);
app.component("BaseCarouselNew", BaseCarouselNew);
app.component("BaseRadio", BaseRadio);
app.component("CashBequestCardComponent", CashBequestCardComponent);
app.component("UnsavedChangesWarningModal", UnsavedChangesWarningModal);
app.mount("#app");